module.exports = __webpack_public_path__ + "img/boda-baile-2.bd22685b.jpg";